/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateMasterReservePayloadDto,
  ErrorResponse,
  MasterReserveListResponseDto,
  MasterReserveResponseDto,
} from '../models/index';
import {
    CreateMasterReservePayloadDtoFromJSON,
    CreateMasterReservePayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MasterReserveListResponseDtoFromJSON,
    MasterReserveListResponseDtoToJSON,
    MasterReserveResponseDtoFromJSON,
    MasterReserveResponseDtoToJSON,
} from '../models/index';

export interface CreateMasterReserveRequest {
    claimId: string;
    createMasterReservePayloadDto: CreateMasterReservePayloadDto;
}

export interface GetMasterReserveListByClaimIdRequest {
    claimId: string;
    currency?: string;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class ClaimMasterReserveApi extends runtime.BaseAPI {

    /**
     * Create master reserve
     */
    async createMasterReserveRaw(requestParameters: CreateMasterReserveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MasterReserveResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createMasterReserve().'
            );
        }

        if (requestParameters['createMasterReservePayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createMasterReservePayloadDto',
                'Required parameter "createMasterReservePayloadDto" was null or undefined when calling createMasterReserve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claim/{claimId}/master-reserve`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMasterReservePayloadDtoToJSON(requestParameters['createMasterReservePayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MasterReserveResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create master reserve
     */
    async createMasterReserve(requestParameters: CreateMasterReserveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MasterReserveResponseDto> {
        const response = await this.createMasterReserveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list master reserve by claim id
     */
    async getMasterReserveListByClaimIdRaw(requestParameters: GetMasterReserveListByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MasterReserveListResponseDto>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getMasterReserveListByClaimId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currency'] != null) {
            queryParameters['currency'] = requestParameters['currency'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/claim/{claimId}/master-reserve`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MasterReserveListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get list master reserve by claim id
     */
    async getMasterReserveListByClaimId(requestParameters: GetMasterReserveListByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MasterReserveListResponseDto> {
        const response = await this.getMasterReserveListByClaimIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
